/***
*
*   DASHBOARD
*   Template dashboard example demonstrating various components inside a view.
*
**********/

import React, { useState, useContext, useEffect } from 'react';
import { Card, Stat, Chart,
  Grid, Animate, Feedback, useAPI, AuthContext, Quiz1, Quiz2, ActivityProgress, Select } from 'components/lib';
import axios from 'axios';
import './dashboard.scss';

export function Dashboard(props){
  const authContext = useContext(AuthContext);
  const [onboard, setOnboard] = useState(null);
  const [form, setForm] = useState({});
  const [campaignOptions, setCampaignOptions] = useState([]);
  const [campaignStats, setCampaignStats] = useState({});
  const [delivered, setDelivered] = useState({});
  const [failed, setFailed] = useState({});
  const [campaignLength, setCampaignLength] = useState(0);
  const [opened, setOpened] = useState(0);
  const [clicks, setClicked] = useState(0);
  const [existDelivered, setExistDelivered] = useState(false);
  const [campaignStatusMails, setCampaignStatusMails] = useState({});

  // hide is used to close 3rd form when state is rendered
  const [hide, setHide] = useState(false);

  const stats = useAPI('/api/demo/stats');
  const campaignListByAccount = useAPI('/api/user/campListByAccount');
  const campaignList = useAPI('/api/user/campaign');
  const leadList = useAPI('/api/user/lead');

  const login = localStorage.getItem('login');

  useEffect(() => {
    // was an error message passed from the server router?
    getUser();
    if(campaignListByAccount?.data?.length > 0) {
      let campaignOptionsArray = [];
      for(let i = 0; i < campaignListByAccount.data.length; i++){
        campaignOptionsArray = [...campaignOptionsArray, {
          label: campaignListByAccount.data[i].campaignName,
          value: campaignListByAccount.data[i].id,
        }]
      }
      setCampaignOptions(campaignOptionsArray);
    }

  }, [authContext.user, campaignListByAccount]);

  async function getUser() {
    try {
      let res = await axios({

        method: 'GET',
        url: '/api/user',
        data: authContext.user.accounts[0].user_id
    
      });

      if(res.data.data && res.data.data.scope === null && res.data.data.target === null) {
        setOnboard('onboarding_1')
      }
      if(res.data.data && res.data.data.scope !== null && res.data.data.target === null) {
        setOnboard('onboarding_2')
      }
      if(res.data.data && res.data.data.scope !== null && res.data.data.target !== null) {
        setOnboard('onboarding_3')
      }

    } catch (err) {
      setOnboard('onboarding_1');
    }
  }

  const onLocalStorage = () => {
    localStorage.setItem('login', '')
    setHide(true)
  }

  const formData = (data) => {
    let aux ={}
    if(data) {
      for(let key in data) {
        if(data[key]["value"]) {
          if(typeof data[key]["value"] === 'object') {
            aux[key] = data[key]
          } else {
            aux[key] = data[key]
          }
        }
      }
    }
    
    let obj = {...form, ...aux}

    setForm(obj)
  }

  const getCampaignStats = async (ev, val) => {
    setExistDelivered(false);
    let res = await axios.post('/api/user/dataCampaignById', { 
      campaignId: val
    });

    if(res?.data?.data?.length !== 0) {
      let openedTimestamp = [];
      let clickedTimestamp = [];
      let totalOpened = 0;
      let totalClicked = 0;
      let dataList = res.data.data;
      let countDelivered = 0;
      let countFailed = 0;

      setCampaignLength(res?.data?.data.length ? res?.data?.data.length : 0);

      dataList.forEach(val => {
        let aux = val;

        if(aux?.clean_data?.opened?.length && aux?.clean_data?.opened?.length !== 0) {
          for(let i = 0; i < aux.clean_data.opened.length; i++) {
            openedTimestamp = [...openedTimestamp, aux.clean_data.opened[i]];
          }
        }

        if(aux?.clean_data?.clicked?.length && aux?.clean_data?.clicked?.length !== 0) {
          for(let i = 0; i < aux.clean_data.clicked.length; i++) {
            clickedTimestamp = [...clickedTimestamp, aux.clean_data.clicked[i]];
          }
        }

        if(aux?.delivered || aux?.failed) {
          setExistDelivered(true);

          if(aux?.delivered?.status) {
            countDelivered = countDelivered + 1;
          }
  
          if(aux?.failed?.status) {
            countFailed = countFailed + 1;
          }
        }
      });

      let percentageDelivered = countDelivered * 100 / res?.data?.data?.length;
      const deliveredData = {
        value: countDelivered,
        percentage: percentageDelivered  
      }
      let percentageFailed = countFailed * 100 / res?.data?.data?.length;
      const failedData = {
        value: countFailed,
        percentage: percentageFailed  
      }

      setDelivered(deliveredData);
      setFailed(failedData);
      const dataArr = new Set(openedTimestamp.sort(function(a, b){return a - b}));
      const dataArr2 = new Set(clickedTimestamp.sort(function(a, b){return a - b}));

      let timestampRepeatedRemoved = [...dataArr].map(val => new Date(val * 1000));
      let timestampRepeatedRemovedClicked = [...dataArr2].map(val => new Date(val * 1000));

      let timestampRepeatedRemovedStringDate = timestampRepeatedRemoved.map(date => date.getDate() + '-' + (date.getMonth() + 1) + '-' + date.getFullYear());
      let timestampRepeatedRemovedStringDateClicked = timestampRepeatedRemovedClicked.map(date => date.getDate() + '-' + (date.getMonth() + 1) + '-' + date.getFullYear());

      const timestampRepeatedStringDateRemoved = new Set(timestampRepeatedRemovedStringDate);

      const timestampRepeatedStringDateRemovedArray = [...timestampRepeatedStringDateRemoved]

      const occurrences = timestampRepeatedRemovedStringDate.reduce(function (acc, curr) {
        return acc[curr] ? ++acc[curr] : acc[curr] = 1, acc
      }, {});
      const occurrencesClicked = timestampRepeatedRemovedStringDateClicked.reduce(function (acc, curr) {
        return acc[curr] ? ++acc[curr] : acc[curr] = 1, acc
      }, {});
      
      let data = [];
      for(let key in occurrences) {
        data = [...data, occurrences[key]]
      }
      let dataClicked = [];
      for(let key in occurrencesClicked) {
        dataClicked = [...dataClicked, occurrencesClicked[key]]
      }

      for(let key in occurrences) {
        totalOpened = totalOpened + occurrences[key];
      }
      for(let key in occurrencesClicked) {
        totalClicked = totalClicked + occurrencesClicked[key];
      }

      setOpened(totalOpened);
      setClicked(totalClicked);

      let objDataFormat = {
        labels: timestampRepeatedStringDateRemovedArray,
        datasets: [
          { 
            label: 'Aperturas de campaña por fecha', 
            data,
            backgroundColor: 'rgba(0, 217, 239, 0.5)',
          },
          { 
            label: 'Clicks de botones con url por fecha', 
            data: dataClicked,
            backgroundColor: 'rgba(71, 215, 172, 0.5)',
          }
        ]
      }

      let objDataFormatPieChart = {
        labels: ['Entregados', 'Fallidos'],
        datasets: [
          { 
            label: 'Estado de los correos enviados por campañas', 
            data: [countDelivered, countFailed],
            backgroundColor: [
              'rgba(0, 217, 239, 1)',
              'rgba(71, 215, 172, 1)',
            ],
            borderColor: [
              'rgba(0, 217, 239, 1)',
              'rgba(71, 215, 172, 1)',
            ],
            borderWidth: 1,
          },
        ]
      }

      setCampaignStats(objDataFormat);
      setCampaignStatusMails(objDataFormatPieChart);
    }
  }

  return (
    <Animate type='pop'>
      {login === 'yes' && onboard === 'onboarding_1' &&
        <Quiz1 onboard={onboard} setOnboard={setOnboard} formData={formData}/>
      }
      {login === 'yes' && onboard === 'onboarding_2' && 
        <Quiz2 onboard={onboard} setOnboard={setOnboard} formData={formData}/>
      }
      {login === 'yes' && onboard === 'onboarding_3' && (!authContext?.user?.isEmailVerified || campaignList?.data?.length === 0 || leadList?.data?.length === 0 || !authContext?.user?.accounts[0]?.domain ) ?
        <ActivityProgress onboard={onboard} setOnboard={setOnboard} onLocalStorage={onLocalStorage} leadList={leadList.data} campaignList={campaignList.data} email={authContext?.user?.email || ''}/> 
        : null
      }
      
      <div style={{ width: '50%' }}>
        <Select label='Selecciona una campaña' options={campaignOptions} onChange={getCampaignStats}/>
      </div>

      {campaignStats?.datasets?.length > 0 &&
        <div>
          <Grid cols='4'>
            <Stat
              loading={ stats?.loading }
              value={ opened }
              label='Aperturas'
              icon='book'
            />
            <Stat
              loading={ stats?.loading }
              value={ clicks }
              label='Clicks'
              icon='check'
            />

            {existDelivered &&
              <Stat
                loading={ stats?.loading }
                value={ delivered.value }
                percentage={ delivered.percentage }
                label='Entregados'
                icon='send'
                length={ campaignLength }
              />
            }

            {existDelivered &&
              <Stat
                loading={ stats?.loading }
                value={ failed.value }
                percentage={ failed.percentage }
                label='Fallidos'
                icon='x-circle'
                length={ campaignLength }
              />
            }
          </Grid>
          <Grid cols='2'>
            <div>
              <h4>
                Gráfico de barras de aperturas y clicks en los correos
              </h4>
              {campaignStats?.labels && campaignStats?.datasets &&
                <Card name='stats' >
                  <Chart
                    type='bar'
                    loading={ campaignStats.length === 0 }
                    data={ campaignStats }
                    color={['blue', 'red']}
                  />
                </Card>
              }
            </div>
            <div>
              <h4>
                Gráfico de correos entregados y fallidos
              </h4>
              {campaignStatusMails?.labels && campaignStatusMails?.datasets &&
                <Card name='stats' >
                  <Chart
                    type='pie'
                    loading={ campaignStatusMails.length === 0 }
                    data={ campaignStatusMails }
                    color={['blue', 'red']}
                  />
                </Card>
              }
            </div>
          </Grid>
        </div>
      }

      <Feedback />

    </Animate>
  );
}
